// extracted by mini-css-extract-plugin
export default {"wrapper":"Share_wrapper__oOGhG","content":"Share_content__l+zsO"};